{
    "back": "Back",
    "backHome": "Back to Home page",
    "brand": "VNGGames Card",
    "buyMore": "Buy more",
    "buyNow": "BUY NOW",
    "buyWith": "Pay with",
    "cannotGetVoucherInfo": "Cannot retrieve your cards information.",
    "cardName": "Name",
    "cardPin": "PIN",
    "cards": "Cards",
    "cardSerial": "Seri Num",
    "checkAgain": "Check again",
    "checkEmail": "Please check your email before purchasing.",
    "checkOrderStatusAgainHint1": "We haven't received payment information for your order.",
    "checkOrderStatusAgainHint2": "Please check and verify the payment details.",
    "checkOrderStatusHint": "Checking transaction results, please wait...",
    "checkout": "Checkout",
    "copied": "Copied!",
    "copyright": "Copyright © 2023 VNG Corp. All rights reserved.",
    "date": "Date",
    "discount": "Discount",
    "discountNotIncluded": "(Discount not included)",
    "emptyCard": "Empty cart! Please select a card to proceed.",
    "emptyOrder": "There is nothing in here. Fill me up",
    "emptyProductionText": "Opps! There are currently no suitable products for you",
    "endSlogan": "the higher the discount you can get.",
    "errorPage": {
        "description": "An unexpected error occurred so we couldn't complete your request.",
        "description2": "Please try again.",
        "goBack": "Go back",
        "title": "Internal Server Error!"
    },
    "errors": {
        "common": "Oops, An error occurred, please try again later"
    },
    "evoucherName": "Card Name",
    "found": "found",
    "gameInMarket": "Games that accept VNGGames Card",
    "onlyApplicableRegion": "Only applicable region can be used VNGGames Card",
    "goBack": "Go back",
    "goBackInTime": "Go back in %{countdown} (seconds)",
    "login": "Login",
    "loginHint": "Please log in to continue",
    "logout": "Logout",
    "membershipCard": "Membership Card",
    "name": "Name",
    "notFound": {
        "goToHome": "Please direct to another page or go to Home Page",
        "pageNotExist": "The page you are looking for does not exist.",
        "title": "Page not found!"
    },
    "notLoginHint": "You are not logged in.",
    "orderDate": "Order Date",
    "orderId": "Order ID",
    "orderMinLimitHint": "The order value cannot be less than",
    "orderMaxLimitHint": "The order value cannot be greater than",
    "paid": "Paid",
    "paymentFailed": "<b>Oops! Payment Failed</b>",
    "paymentFailedHint": "Payment for Order ID <b>%{orderId}</b> could not be processed. <br/> Try again.",
    "paymentHint": "By clicking the BUY NOW you agree that this transaction is NON-REFUNDABLE and NON-RETURNABLE.",
    "paymentMethod": "Payment method",
    "paymentStatus": "Payment status",
    "paymentSuccess": "Payment success",
    "paymentSuccessHint": "The order and payment details have been sent to your email <b class='color-primary'>%{userEmail}</b>.",
    "pleaseCheck": "Please check.",
    "price": "Price",
    "purchaseHistory": "My Orders",
    "myCards": "My Cards",
    "quantity": "Quantity",
    "redirectToPaymentProviderHint": "You are being directed to our partner site for payment processing",
    "register": "Register",
    "results": "results",
    "retryAgain": "Retry again",
    "retryCheckOrder": "I have already made the payment, check again.",
    "seeDetailVoucherList": "See the details of your cards",
    "sentCardToMail": "The order and payment details will be sent to your email",
    "showCards": "Show cards",
    "startSlogan": "The more you buy",
    "status": "Status",
    "subTotal": "Sub Total",
    "supportCenter": "Support Center",
    "titleCardSelling": "The reputable game card-selling website of VNGGames",
    "total": "Total",
    "transactionId": "Transaction ID:",
    "tryAgain": "Try again",
    "yourOrder": "Your cart",
    "logoutLoadingHint": "Logging out...",
    "loginLoadingHint": "Logging in...",
    "myProfile": "My Profile",
    "buyCards": "Buy Cards",
    "termsOfSale": "Terms Of Sale",
    "termsOfUse": "Terms Of Use",
    "privacyPolicy": "Privacy Policy",
    "userGuide": {
        "title": "User Guide",
        "chap1": "I. VNGGames Card",
        "viewProductsListTitle": "1. View products list",
        "registerTitle": "2. Register",
        "loginTitle": "3. Login",
        "buyCardTitle": "4. Buy VNGGames Card",
        "orderHistoyTitle": "5. Order History",
        "cardManagementTitle": "6. Card Management",
        "chap2": "II. Redeem on VNGGames shop",
        "accessVGC": "Step 1: Access VNGGames Card",
        "clickBuyNow": "Step 2: Click the 'BUY NOW' button or Buy Cards",
        "clickUserIconStep1": "Step 1: Click user icon.",
        "clickUserIconStep2": "Step 2: Click user icon.",
        "clickCreateAccount": "Step 2: Click 'Create VNGGames account' to create a VNGGames account.",
        "step3": "Step 3:",
        "step3EnterRegisteredEmail": "Enter a valid email that has not been previously used to register on VNGGames Card",
        "step3AgreePrivacyPolicy": "Select \"I agree to the privacy policy\"",
        "step3ClickContinue": "Click Continue button",
        "note": "Note:",
        "clickToReadPrivacyPolicy": "User can click \"privacy policy\" to read the info before select \"I agree to the privacy policy\".",
        "displayExistedEmail": "If the user uses an email that already exists, after clicking the 'Continue' button, the message \"The email exists\" will be displayed.",
        "enterValidPasswordRegister": "Step 4: Enter a valid password and click the 'Continue' button",
        "enterActivationCode": "Step 5: Enter the activation code sent to your email and click the 'Continue' button.",
        "activationCodeTimeout": "The Activation Code is only valid for 60 seconds.",
        "resendActivationCode": "If you don’t receive the verification code or code expired, you can click the 'Resend code'.",
        "enterPersonalInfo": "Step 6: Enter your personal information in the following form and click the 'Continue' button.",
        "completeRegistration": "Step 7: Click the 'Continue' button to complete the creation of your VNGGames account and access VNGGames Card.",
        "redirectToBuyCard": "Step 8: After successfully creating the VNGGames account, the user will be redirected to the buy cards page.",
        "enterRegisteredEmail": "Step 3: Enter your registered Email and click the 'Continue' button.",
        "enterValidPasswordLogin": "Step 4: Enter a valid password and click the 'Continue' button. The user will be redirected to the buy cards page.",
        "retypeEmail": "If the user wants to re-enter the email, they can click the 'Retype email' button.",
        "recoverPassword": "If the user does not remember the password, they can click 'Recover password' to retrieve it.",
        "selectMarket": "Step 1: Select the market where user want to buy the card.",
        "selectQuantity": "Step 2: Select the quantity of cards you want to purchase.",
        "cardLimitation": "Users can select multiple cards, with a maximum quantity of 99 cards per type, within the allowed value limit.",
        "limitationRangeHighlight": "If the order value is less than or greater than the allowed value limit, the minimum/maximum limit notification will be highlighted in red, and BUY NOW will be disabled.",
        "verifyCart": "Step 3: Verify your cart, select a payment method, and click the 'BUY NOW' button to proceed with the payment.",
        "readTermsOfSale": "Before pressing the BUY NOW button, you should read our sales terms by clicking on 'Terms Of Sale'.",
        "partnerWebsite": "Step 4: Proceed with the payment on the partner's website.",
        "viewTransactionDetailsBuyCard": "Step 5: View transaction result or click on See the details of your cards.",
        "clickBuyMore": "Click BUY MORE button to continue buying cards.",
        "clickBackToHome": "Click Back to Home page to return to the homepage.",
        "checkOrderAndPayment": "Step 6: Users can check the order and payment info VNGGames Card by:",
        "checkOrderAndPaymentMethod1": "Method 1: Check the received email after a successful card purchase, and click on the Order page within the email content.",
        "goToOrderPage": "When you click on the Order page, you will be redirected to the payment result page, and you need to log in with the correct VNGGames Card account that you used to purchase the card earlier.",
        "checkOrderAndPaymentMethod2": "Method 2: Go to the My Orders page and check under section 5. Order History.",
        "checkOrderAndPaymentMethod3": "Method 3: Go to the My Cards page and check under section 6. Card Management.",
        "clickMyOrders": "Step 1: Click the 'My Orders' button.",
        "viewOrderHistory": "Step 2: View the order history.",
        "orderHistoryFilter": "Users can filter their order history based on Date, Status, and payment method",
        "clickOrderId": "Users can click Order ID to see the details",
        "clickMyCardButton": "Step 1: Click the 'My Card' button.",
        "enterVerifyOTP": "Step 2: Enter the activation OTP sent to your email and click the 'Continue' button.",
        "myCardOTPTimeout": "The activation OTP is only valid for 5 minutes.",
        "resendOTP": "If you don’t receive the verification OTP or OTP expired, you can click the 'Resend OTP'.",
        "durationBetween2OTP": "The time between each Resend OTP is 60 seconds.",
        "wrong3TimesARow": "If you enter the wrong OTP more than 3 times in a row within 2 hours, your OTP verification will be locked for 10 minutes.",
        "remainingResend": "If your OTP verification is locked for 10 minutes but you are still able to Resend OTP, after clicking on Resend OTP, you will still be able to enter a new OTP.",
        "resendOtp2TimeInHour": "If you request to send OTP more than 3 times within 2 hours, your Resend OTP function will be locked for 15 minutes.",
        "redirectToMyCards": "After successfully verify OTP, the user will be redirected to My Cards details page",
        "userCanSearchCardBy": "Step 3: User can search card by:",
        "enterInputField": "Enter Order ID or Card name into Order ID / Card name field",
        "clickPurchaseDate": "Click on Purchased date field:",
        "selectFromToDate": "Select From date - To date",
        "selectLastWeek": "Select Last week",
        "selectLastMonth": "Select Last month",
        "select3Months": "Select 3 months",
        "clickCardStatus": "Click on Card status field:",
        "selectAll": "Select All",
        "selectSold": "Select Sold",
        "selectAvailable": "Select Available",
        "selectCardsToAction": "Step 4: Select each card individually or choose all cards, then click on Mark as SOLD/Copy/Email/Export.",
        "markAsSold": "Mark as SOLD: After selling a card, you can mark it as SOLD.",
        "copyCard": "Copy: Used to copy the information of the selected cards.",
        "exportCard": "Export: Used to export the selected cards to a PDF file.",
        "emailCard": "Email: Used to send the information of the selected cards via email.",
        "sendToMe": "Users can send an email to themselves by selecting \"Send to my mail\" and then clicking the \"Send mail\" button.",
        "sentToOther": "Users can send an email to someone else by selecting \"Send to other email\", entering the recipient's email address in the \"Receiver email\" field, and clicking the \"Send mail\" button.",
        "markAsSoldEmail": "Users can click on \"Mark all cards as SOLD\" to mark the cards as SOLD after sending them.",
        "emailSendLimitation": "Users can only send a maximum of 10 emails within a 24-hour period. After 24 hours, the email sending limit will be reset.",
        "clickEmailHistoryToView": "Step 5: Click Email History to review previously sent emails.",
        "processRedeem": "After the user has successfully purchased the card on VNGGames Card, the user can proceed to redeem on VNGGames shop.",
        "accessVNGGamesShopAndLogin": "Step 1: Access VNGGames shop game and login",
        "indonesia": "Indonesia",
        "philiphines": "Philippines",
        "thailand": "Thailand",
        "malaysia": "Malaysia",
        "singapore": "Singapore",
        "marketLimitation": "Cards purchased in any market are properly applied to the VNGGames shop of that market.",
        "selectVGCMethod": "Step 2: Select VNGGames Card method.",
        "selectSuitablePackage": "Step 3: Select a package with a fixed price that matches the value of the card purchased on VNGGames Card.",
        "inputSerialAndPIN": "Step 4: Input valid Serial Number + PIN.",
        "clickRedeemButton": "Step 5: Click 'Redeem' button.",
        "viewTransactionAndCheckInGame": "Step 6: View transaction result and check ingame.",
        "lastModified": "Last modified: 24 July 2023"



    },
    "faq": {
		"title": "FAQ",
		"whatIsVNGGamesCard": "What is VNGGAMES CARD?",
        "benefits": "Benefits of paying for games with VNGGames Card",
        "whereToPurchase": "Where can I purchase VNGGames Card?",
        "howToRedeem": "How to redeem games with VNGGames Card?",
        "errorWhenRedeem": "Error when redeem games with VNGGames Card",
        "errorWhenPurchaseViaBank": "Error when purchase VNGGames Card via Banks",
        "errorWhenPurchaseViaEWallet": "Error Payment with E-wallet"
	},
    "regionLockedProductHint": "VNGGames Card is a region locked product. All purchases are NON-REFUNDABLE and NON-RETURNABLE. Please carefully select your region before buying.",
    "chooseMarket": "Choose your market",
    "successful": "Successful",
    "failed": "Failed",
    "andMore": "and more",
    "tosAgreementHint": "By clicking BUY NOW, you agree to our",
    "all": "All",
    "duration": {
        "oneWeek": "1 Week ago",
        "oneMonth": "1 Month ago",
        "threeMonths": "3 Months ago"
    },
	"selectPaymentMethodHint": "Select your payment method",
	"selectLanguageHint": "Select your language",
	"links": "Links",
	"generatingCardHint": "Generating cards, please wait...",
	"sessionTimeout": "Your session has timed out. Please login again.",
	"copy": "Copy",
    "menu": "Menu",
    "searchInputPlaceholder": "Search by Order ID / Card Name",
    "cardValue": "Card Value",
    "cardSelected": "%{totalCardSelected} cards selected",
    "markAsSold": "Mark %{totalCardSelected} as SOLD",
    "markAsSoldShort": "Mark as SOLD",
    "email": "Email",
    "export": "Export",
    "to": "To",
    "startDate": "Start date",
    "endDate": "End date",
    "lastWeek": "Last week",
    "lastMonth": "Last month",
    "last3Months": "Last 3 months",
    "purchased": "Purchased",
    "purchasedDate": "Purchased date",
    "orderIdOrCardName": "Order ID / Card name",
    "typeToSearch": "Type to search",
    "cardsCopiedSucessfully": "Cards copied successfully!",
    "expires": "Expires",
    "sold": "Sold",
    "validUntil": "Valid until",
    "available": "Available",
    "homepage": "Homepage",
    "error": "Error",
    "verifyOtp": {
        "title": "Check your email",
        "emailHint": "An One-Time Password (OTP) has been sent to the email address",
        "label": "One-Time Password",
        "buttonVerify": "Verify",
        "resendOtp": "Resend OTP",
        "required": "This field is required",
        "invalid": "OTP is invalid or expired",
        "requestLimited": "OTP request attempts exceeded, locked temporarily.",
        "validateLimited": "OTP verification attempts exceeded, locked temporarily.",
        "resendHint": "We have sent a new OTP to your email address."
    },
    "cardInventory": {
        "markAsSoldHint": "Please select at least one card!",
        "markAsSoldSuccess": "Mark as sold successfully!",
        "twoFactorExpired": "Please verify your identity as your session has expired.",
        "copyCardHint": "Please select at least one card!",
        "copyCardSuccess": "Cards information copied!",
        "sendEmailHint": "Please select at least one card!",
        "exportFileHint": "Please select at least one card!",
        "exportFileSuccess": "Export file successfully! Please check your download folder.",
        "sendEmailTitle": "Send email",
        "sendToMyEmail": "Send to my email (%{userEmail})",
        "sendToOther": "Send to other email",
        "receiverEmail": "Receiver email",
        "markAllAsSold": "Mark all cards as SOLD",
        "sendEmailButton": "Send email",
        "sendMailSuccess": "Send email successfully!",
        "errorIsRequired": "This field is required",
        "errorInvalidFormat": "Invalid email format",
        "cardStatusText": "Card status",
        "emailHistory": {
            "title": "Email History",
            "receiverEmail": "Receiver email",
            "sendingTime": "Sending time",
            "emailStatus": "Email status",
            "successful": "Successful",
            "sending": "Sending",
            "failed": "Failed",
            "cardInformation": "Card Information",
            "emailLimitHint": "You have %{currentEmailAvailable} time(s) to send email",
            "until": "until",
            "overLimit": "You have sent over the limit.",
            "pleaseWait": "Please wait until"

        }
    },
    "pagination": {
        "total": "Total",
        "pageSize": "/page",
        "goTo": "Go to"
    },
    "changeDomainToast": {
        "part1": "NEW website address",
        "part2": "shop.vnggames.com/card",
        "part3": "changed from Jan 15th, 2024"
    }

}
